import React, {useEffect, useRef, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Button, Card, Grid} from 'semantic-ui-react';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import TasksTable from './tasksTable';
import {getColumns} from './tasksTableColumns';

const {
  fetchLogisticTasksList,
  updateLogisticTask,
  createLogisticTask,
  navigateTo,
  fetchLogisticAreasList,
} = Actions;

const NEW_TASK_OBJ = {
  'serviceCode1': '',
  'serviceCode2': '',
  'serviceCode3': '',
  'description': '',
  'stdFlat': 0,
  'uniqueId': '',
};

const LogisticTasks = () => {
  const permissions = useSelector((state) => state.session.permissions);
  const logisticTasks = useSelector((state) => state.logisticTasks.list);
  const logisticTasksAreas = useSelector((state) => state.logisticServices.list);
  const [taskToEdit, setTaskToEdit] = useState(null);
  const [lastInputChanged, setLastInputChanged] = useState({'inputId': null, 'caretPos': 0});
  const [currentPage, setCurrentPage] = useState(0);
  const [addTask, setAddTask] = useState(null);
  let inputRef = useRef();
  const InputsRefs = [];
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.LogisticTasks, scopes.See) &&
     !hasAccessPermission(permissions, resources.LogisticTasks, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(fetchLogisticTasksList());
    dispatch(fetchLogisticAreasList());
  }, [dispatch]);
  

  const setRef = (input) => {
    inputRef = input;
    InputsRefs.push(inputRef);
  };

  const editTask = (e, currentPage) => {
    e.preventDefault();
    dispatch(updateLogisticTask(taskToEdit));
  };

  const disableTask = (e, input, task) => {
    e.preventDefault();
    dispatch(updateLogisticTask({...task, 'status': input.checked ? 'A' : 'P'}));
  };

  const createTask = (e) => {
    e.preventDefault();
    dispatch(createLogisticTask({'task': addTask}));
  };

  useEffect(() => {
    const input = InputsRefs.find((x) => x.props.id === lastInputChanged.inputId);
    if (input && taskToEdit) {
      input.focus();
      input.inputRef.current
        .setSelectionRange(lastInputChanged.caretPos, lastInputChanged.caretPos);
    }
  }, [taskToEdit]);

  useEffect(() => {
    setAddTask(null);
    setTaskToEdit(null);
  }, [logisticTasks]);

  const columns = getColumns();

  return (<>
    <Card raised fluid>
      <div className='title-bar'>
        <Grid>
          <Grid.Row verticalAlign='middle'>
            <Grid.Column width={8}>
              <div className='title'>
                <h2>Tareas de Logística</h2>
              </div>
            </Grid.Column>
            <Grid.Column width={8} textAlign='right'>
              <Button primary onClick={() => setAddTask(NEW_TASK_OBJ)}
                disabled={addTask ? true : false}> CREAR TAREA</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </Card>
    <Card raised fluid>
      <Card.Content>
        <TasksTable tableColumns={columns} tableData={logisticTasks}
          add={{addTask, createTask, setAddTask,
            logisticTasksAreas, setRef, setLastInputChanged}}
          edit={{taskToEdit, setTaskToEdit, setRef, setLastInputChanged,
            editTask, disableTask, setCurrentPage, currentPage}} />
      </Card.Content>
    </Card>
  </>
  );
};

export default LogisticTasks;
